import { z } from 'zod';
import type {
    DraftValorCredentials,
    ValorCredentials,
    ValorCredentialsPublic,
    ValorCredentialsSecret,
} from '../../../types/ipg/valor/valor-credential.types';

export const ValorCredentialsPublicSchema: z.ZodObject<{
    domain: z.ZodString;
    channel: z.ZodString;
    epi: z.ZodString;
}> = z.object({
    domain: z.string().url(),
    channel: z.string().min(1),
    epi: z.string(),
}) satisfies z.ZodType<ValorCredentialsPublic>;

export const ValorCredentialsSecretSchema: z.ZodObject<{
    appid: z.ZodString;
    appkey: z.ZodString;
}> = z.object({
    appid: z.string(),
    appkey: z.string(),
}) satisfies z.ZodType<ValorCredentialsSecret>;

export const ValorCredentialsSchema: z.ZodType<ValorCredentials> =
    ValorCredentialsPublicSchema.merge(ValorCredentialsSecretSchema);

export const DraftValorCredentialsSchema: z.ZodType<DraftValorCredentials> = z
    .object({
        domain: z.string().url().optional(),
        epi: z.string().min(1).optional(),
        appid: z.string().min(1).optional(),
        appkey: z.string().min(1).optional(),
        channel: z.string().min(1).optional(),
    })
    .refine((value) => Object.keys(value).length > 0, {
        message: 'At least one credential field is required',
    });
